import React from "react";
import { MapPin, Search, Navigation, Terminal } from "lucide-react";

export default function JpsyMaps({ onTabChange }) {
  return (
    <div className="flex-1 bg-white font-sans">
      <section className="bg-[#111215] text-white py-16 px-6 relative overflow-hidden border-b-4 border-[#263f98]">
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#263f98]/10 rounded-full filter blur-3xl" />
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-12 relative z-10">
          <div className="space-y-6 max-w-2xl">
            <span className="bg-[#263f98] text-white text-[10px] uppercase font-bold tracking-widest px-3 py-1 rounded">
              Spatial Technology (Beta)
            </span>
            <h1 className="text-4xl sm:text-5xl font-sans font-black tracking-tight leading-tight">
              JPSY Maps{" "}
              <span className="text-[#263f98] font-mono">Location APIs</span>
            </h1>
            <p className="text-slate-300 text-lg leading-relaxed">
              India's premier location engine. Cleanse, validate, and geocode
              complex, unformatted unstructured physical postal addresses into
              precise GPS lat/lng points automatically.
            </p>
            <div className="flex gap-4">
              <button
                onClick={() => onTabChange("dashboard")}
                className="bg-[#263f98] hover:bg-[#1f2f82] active:bg-[#21185f] text-white font-bold px-6 py-3 rounded-xl transition-colors shadow-lg flex items-center gap-2 text-sm cursor-pointer"
              >
                <span>Read Developer API Docs</span>
              </button>
            </div>
          </div>
          <div className="w-full md:w-80 bg-slate-900 border border-slate-800 rounded-2xl p-6 text-slate-300 space-y-4">
            <h3 className="font-bold text-white font-sans text-sm tracking-wider uppercase border-b border-slate-800 pb-2">
              API Sandbox Stats
            </h3>
            <div className="space-y-3 text-xs">
              <div className="flex justify-between">
                <span>Address Verification</span>
                <span className="font-bold text-emerald-400">
                  98.5% Accuracy
                </span>
              </div>
              <div className="flex justify-between">
                <span>Geocoding Speeds</span>
                <span className="font-bold text-white">&lt; 85ms Response</span>
              </div>
              <div className="flex justify-between">
                <span>Pincode Corridors</span>
                <span className="font-bold text-white">19,000+ Mapped</span>
              </div>
              <div className="flex justify-between">
                <span>Query Limit (Sandbox)</span>
                <span className="font-bold text-white">
                  10,000 free / month
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="bg-slate-50 border border-slate-200 p-8 rounded-2xl space-y-4">
          <div className="w-12 h-12 rounded-xl bg-[#263f98]/10 text-[#263f98] flex items-center justify-center font-bold">
            <Search className="w-6 h-6" />
          </div>
          <h3 className="text-xl font-bold text-slate-900 font-sans">
            Address Parsing API
          </h3>
          <p className="text-sm text-slate-500 leading-relaxed">
            Automatically splits disorganized, long-form address text fields
            into structured fields including state, city, sub-locality, building
            number, and verified postal codes.
          </p>
        </div>

        <div className="bg-slate-50 border border-slate-200 p-8 rounded-2xl space-y-4">
          <div className="w-12 h-12 rounded-xl bg-[#263f98]/10 text-[#263f98] flex items-center justify-center font-bold">
            <MapPin className="w-6 h-6" />
          </div>
          <h3 className="text-xl font-bold text-slate-900 font-sans">
            Geofence Boundaries
          </h3>
          <p className="text-sm text-slate-500 leading-relaxed">
            Create high-accuracy custom delivery gates. Signals vehicle drivers
            with exact access roads, gate security codes, and localized delivery
            point parking spaces.
          </p>
        </div>

        <div className="bg-slate-50 border border-slate-200 p-8 rounded-2xl space-y-4">
          <div className="w-12 h-12 rounded-xl bg-[#263f98]/10 text-[#263f98] flex items-center justify-center font-bold">
            <Navigation className="w-6 h-6" />
          </div>
          <h3 className="text-xl font-bold text-slate-900 font-sans">
            Last-Mile Routing GPS
          </h3>
          <p className="text-sm text-slate-500 leading-relaxed">
            Custom motorcycle and delivery-truck route calculations. Avoids
            restricted one-ways, narrow alleys, and unpaved pathways, boosting
            last-mile speeds.
          </p>
        </div>
      </section>

      {/* Code Sandbox Mock */}
      <section className="bg-slate-950 py-16 px-6 text-slate-300">
        <div className="max-w-4xl mx-auto space-y-6">
          <div className="flex items-center gap-2 border-b border-slate-800 pb-4">
            <Terminal className="w-5 h-5 text-[#263f98]" />
            <h3 className="text-lg font-bold text-white font-mono">
              Address Cleanse Response JSON
            </h3>
          </div>
          <pre className="bg-slate-900 border border-slate-800 rounded-xl p-6 text-xs text-emerald-400 font-mono overflow-x-auto leading-relaxed">
            {`{
  "status": "SUCCESS",
  "input_address": "Flat 304, 3rd floor, block B, apex apartments near axis bank, sector 62, noida, up 201301",
  "parsed_data": {
    "flat_number": "Flat 304",
    "floor": "3rd Floor",
    "building_name": "Apex Apartments",
    "landmark": "Near Axis Bank",
    "sector": "Sector 62",
    "city": "Noida",
    "state": "Uttar Pradesh",
    "pincode": "201301"
  },
  "geocoded": {
    "latitude": 28.6273,
    "longitude": 77.3725,
    "confidence_score": 0.99
  }
}`}
          </pre>
        </div>
      </section>
    </div>
  );
}
